import React, { useState } from 'react';
import LoginImage from './login.jpg';

const Login: React.FC = () => {
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const api = process.env.REACT_APP_API_URL;
  const login = async () => {
    if (!username || !password) {
      setError('Username and password are required');
      return;
    }

    try {
      const response = await fetch(`${api}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
        credentials: 'include', // send cookies if server sets authToken
      });

      const data = await response.json();

      if (response.ok) {
        // redirect based on role
        window.location.href = data.redirect;
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Internal server error');
    }
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <img
        className="w-full md:w-[55%] md:h-[100vh] h-[300px] object-cover"
        src={LoginImage}
        alt="Login Visual"
      />

      <div className="bg-slate-50 w-full md:w-[45%] flex justify-center items-center p-6">
        <div className="bg-white p-6 md:p-8 w-full max-w-md rounded-xl">
          <h4 className="text-[20px] font-bold text-[#414040]">Sign in to account</h4>
          <p className="text-[#898989] text-[14px]">Enter your email & password to login</p>

          {error && <p className="text-red-500 mt-2">{error}</p>}

          <div className="mt-6">
            <label className="block text-[16px] font-medium text-[#555454] mb-1">
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full bg-[#e9ecef] font-bold text-[#555454] px-3 py-2 rounded-md border border-dashed border-[#c0bebe] outline-none placeholder:font-bold placeholder:text-[#555454]"
              placeholder="Enter your username"
            />

            <label className="block text-[16px] font-medium text-[#555454] mt-4 mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#e9ecef] font-bold text-[#555454] px-3 py-2 rounded-md border border-dashed border-[#c0bebe] outline-none placeholder:font-bold placeholder:text-[#555454]"
              placeholder="Enter your password"
            />

            <button
              onClick={login}
              className="bg-[#7a70ba] text-white px-6 py-2 mt-4 w-full rounded-md hover:bg-[#6a60a8] transition-all duration-200"
            >
              Sign in
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
